/**
 * Token management utilities for cookie-based authentication
 *
 * Note: With httpOnly cookies, we cannot access tokens from JavaScript.
 * The server handles token storage and validation automatically via cookies.
 */

/**
 * Since tokens are now stored in httpOnly cookies, we don't need to store them in localStorage.
 * The server will automatically include cookies in requests.
 * @param {string} token - JWT access token (no longer stored client-side)
 */
export const setAuthToken = (token) => {
  // Tokens are now handled server-side via httpOnly cookies
  // No client-side storage needed
  console.log('Token management now handled via httpOnly cookies');
};

/**
 * Since tokens are in httpOnly cookies, we cannot clear them from client-side.
 * Use the /logout endpoint to clear cookies server-side.
 */
export const removeAuthToken = () => {
  // Tokens are cleared server-side via /logout endpoint
  console.log('Token clearing handled server-side');
};

/**
 * Since tokens are in httpOnly cookies, we cannot access them from JavaScript.
 * This function is kept for backward compatibility but will always return null.
 * @returns {null} Always returns null since tokens are not accessible client-side
 */
export const getAuthToken = () => {
  // Cannot access httpOnly cookies from JavaScript
  return null;
};

/**
 * Since tokens are in httpOnly cookies, no client-side initialization is needed.
 * The server automatically handles cookies.
 */
export const initializeAuthToken = () => {
  // No client-side initialization needed for cookie-based auth
  console.log('Auth token initialization handled automatically via cookies');
};

